import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Popup, Table } from 'semantic-ui-react';

import { Fecha, NombrePersonal } from 'src/componentes';
import { ResumenMatricula } from 'src/modulos/Matriculas/comun/tipos';
import EtiquetaDeEstadoAprobacion from './EtiquetaDeEstadoAprobacion';

type FormasPago = 'contado' | 'tarjeta' | 'pagare' | 'cheque';

const nombresFormasPago: Record<FormasPago, string> = {
    contado: 'Contado',
    tarjeta: 'Tarjeta',
    cheque: 'Cheque',
    pagare: 'Pagaré',
};

export const CabeceraSupervisor = () => {
    return (
        <Table.Row>
            <Table.HeaderCell>Números de contrato</Table.HeaderCell>
            <Table.HeaderCell>Responsable</Table.HeaderCell>
            <Table.HeaderCell>Promotor</Table.HeaderCell>
            <Table.HeaderCell>A nombre de</Table.HeaderCell>
            <Table.HeaderCell>Número de pagaré</Table.HeaderCell>
            <Table.HeaderCell>Forma de pago</Table.HeaderCell>
            <Table.HeaderCell>Fecha</Table.HeaderCell>
            <Table.HeaderCell>Estado</Table.HeaderCell>
        </Table.Row>
    );
};

export const FilaSupervisor: React.FC<ResumenMatricula> = props => {
    const {
        id,
        responsable,
        aNombreDe,
        promotor,
        numerosDeContrato,
        numeroDePagare,
        formaDePago,
        fecha,
        estadoVerificacion,
        estadoAprobacion,
        nulo,
    } = props;
    return (
        <Table.Row>
            <Table.Cell selectable>
                <Link to={'supervision/matriculas/' + id.toString()}>
                    <b>{numerosDeContrato.join(', ')}</b>
                </Link>
            </Table.Cell>
            <Table.Cell content={<NombrePersonal nombre={responsable} patron='%N %P' />} />
            <Table.Cell content={promotor} />
            <Table.Cell
                content={aNombreDe && <NombrePersonal nombre={aNombreDe} patron='%N %P' />}
            />
            <Table.Cell content={numeroDePagare} />
            <Table.Cell content={nombresFormasPago[formaDePago]} />
            <Table.Cell content={<Fecha fecha={fecha} />} />
            <Table.Cell singleLine>
                <EtiquetaDeEstadoAprobacion nulo={nulo} estadoAprobacion={estadoAprobacion} />
                <Popup
                    open={estadoVerificacion.estado !== 'pendiente' ? false : undefined}
                    trigger={
                        estadoVerificacion.estado === 'pendiente' && (
                            <Icon name='times' color='black' />
                        )
                    }
                >
                    <Popup.Header />
                    {estadoVerificacion.estado === 'pendiente' && (
                        <Popup.Content>
                            <p style={{ whiteSpace: 'pre-line' }}>
                                {!estadoVerificacion.tieneFirmas && 'Falta firma'}
                            </p>
                            <p style={{ whiteSpace: 'pre-line' }}>
                                {!estadoVerificacion.tieneFotocopias && 'Falta fotocopia'}
                            </p>
                            <p style={{ whiteSpace: 'pre-line' }}>
                                {!estadoVerificacion.tieneHuellas && 'Falta huella'}
                            </p>
                        </Popup.Content>
                    )}
                </Popup>
                {estadoVerificacion.estado === 'verificada' && <Icon name='check' color='green' />}
            </Table.Cell>
        </Table.Row>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/ListaDeProcesos/TablaDeProcesos/FilaSupervisor.tsx